import { request } from 'cn-request';
import isFunction from 'lodash/isFunction';
export function handleRequestService(requestConfig) {
    const { service, url: remoteUrl, params: paramsProps, data: dataProps, formatResult = (res) => {
        if (Array.isArray(res)) {
            return res;
        }
        else if (Array.isArray(res?.data)) {
            return res.data;
        }
        else if (Array.isArray(res?.data?.dataSource)) {
            return res.data.dataSource;
        }
        else if (Array.isArray(res?.data?.data)) {
            return res.data.data;
        }
        else if (Array.isArray(res?.data?.data?.dataSource)) {
            return res.data.data.dataSource;
        }
        return [];
    }, method = 'GET', } = requestConfig || {};
    // 配置了service时，promise由service托管
    if (isFunction(service)) {
        return async (searchConfig) => {
            return service(searchConfig)?.then((data) => {
                const dataSource = formatResult(data);
                return Array.isArray(dataSource) ? dataSource : [];
            });
        };
    }
    // 配置了remoteUrl，promise由cn-request执行
    if (remoteUrl) {
        return async (searchConfig) => {
            const params = method?.toLocaleUpperCase() === 'GET'
                ? { ...searchConfig, ...paramsProps }
                : paramsProps;
            const data = method?.toLocaleUpperCase() === 'POST'
                ? { ...searchConfig, ...dataProps }
                : dataProps;
            const resultData = await request({
                ...requestConfig,
                params,
                data,
                url: remoteUrl,
            });
            const dataSource = formatResult(resultData);
            return (Array.isArray(dataSource) ? dataSource : []);
        };
    }
    // 什么都没配置，返回一个空promise
    // eslint-disable-next-line
    return async (searchConfig) => {
        return [];
    };
}
